import React from "react";

interface StarRatingProps {
  rating: number;
}

const StarRating: React.FC<StarRatingProps> = ({ rating }) => {
  const roundedRating = Math.floor(rating + 1.0);
  const fractionalPart = rating + 1.0 - roundedRating;

  const getStarFillColor = (index: number) => {
    if (index < roundedRating) {
      return "#FFC247"; // Fully colored star for complete rating
    } else if (
      index === roundedRating &&
      fractionalPart > 0 &&
      fractionalPart < 1
    ) {
      return `url(#starGradient${index})`; // Partially colored star
    }
    return "none"; // Default empty star
  };

  const getStarStrokeColor = (index: number) => {
    return index < roundedRating ? "#FFC247" : "silver";
  };

  return (
    <div className="star-rating">
      {[1, 2, 3, 4, 5].map((index) => (
        <span key={index} className="star">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="16"
            height="16"
          >
            {index === roundedRating &&
              fractionalPart > 0 &&
              fractionalPart < 1 && (
                <defs>
                  <linearGradient
                    id={`starGradient${index}`}
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="0%"
                  >
                    <stop
                      offset={`${fractionalPart * 100}%`}
                      stopColor="#FFC247"
                    />
                    <stop
                      offset={`${fractionalPart * 100}%`}
                      stopColor="white"
                    />
                  </linearGradient>
                </defs>
              )}
            <path
              fill={getStarFillColor(index)}
              stroke={getStarStrokeColor(index)}
              strokeWidth="2"
              d="M16.7184 12.3201C16.4594 12.5711 16.3404 12.9341 16.3994 13.2901L17.2884 18.2101C17.3634 18.6271 17.1874 19.0491 16.8384 19.2901C16.4964 19.5401 16.0414 19.5701 15.6684 19.3701L11.2394 17.0601C11.0854 16.9781 10.9144 16.9341 10.7394 16.9291H10.4684C10.3744 16.9431 10.2824 16.9731 10.1984 17.0191L5.76844 19.3401C5.54944 19.4501 5.30144 19.4891 5.05844 19.4501C4.46644 19.3381 4.07144 18.7741 4.16844 18.1791L5.05844 13.2591C5.11744 12.9001 4.99844 12.5351 4.73944 12.2801L1.12844 8.78009C0.826436 8.48709 0.721436 8.04709 0.859436 7.65009C0.993436 7.25409 1.33544 6.96509 1.74844 6.90009L6.71844 6.17909C7.09644 6.14009 7.42844 5.91009 7.59844 5.57009L9.78844 1.08009C9.84044 0.980092 9.90744 0.888092 9.98844 0.810092L10.0784 0.740092C10.1254 0.688092 10.1794 0.645092 10.2394 0.610092L10.3484 0.570092L10.5184 0.500092H10.9394C11.3154 0.539092 11.6464 0.764092 11.8194 1.10009L14.0384 5.57009C14.1984 5.89709 14.5094 6.12409 14.8684 6.17909L19.8384 6.90009C20.2584 6.96009 20.6094 7.25009 20.7484 7.65009C20.8794 8.05109 20.7664 8.49109 20.4584 8.78009L16.7184 12.3201Z"
            />
          </svg>
        </span>
      ))}
    </div>
  );
};

export default StarRating;
